module.exports = __webpack_public_path__ + "img/coolbe.41114a90.png";